// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"b3f624a3","462":"b812baa3","693":"3827d51f"}[chunkId] + ".chunk.js";
};